import classNames from 'classnames';
import React, { CSSProperties } from 'react';
import { default as TextareaAutosize } from 'react-textarea-autosize';

interface Props {
    fill?: boolean;
    id?: string;
    maxLength?: number;
    onChange: (value: string) => void;
    placeholder?: string;
    style?: CSSProperties;
    value?: string;
}

const TextArea: React.SFC<Props> = ({ onChange, fill, ...props }) => {
    const classes = classNames('input-textarea', {
        'input-width--max': fill,
    });

    return (
        <TextareaAutosize
            {...props}
            className={classes}
            onChange={({ target: { value } }) => {
                onChange(value);
            }}
        />
    );
};

TextArea.defaultProps = {
    fill: false,
};

export default TextArea;
